var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.se_puede_actualizar_venta(_vm.sale_details))?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('update-prices'),expression:"'update-prices'"}],staticClass:"m-r-15",attrs:{"variant":"outline-primary"}},[_vm._v(" Actualizar precios ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }